// BeatCredsi Score Ring — 5-tier status colors mapped to a 0-1000 scale,
// with a glowing 7-segment LCD calculator readout in the center.
import LcdDisplay from "@/components/LcdDisplay";

export default function HealthScoreRing({ score = 0, max = 1000, status, size = 220 }) {
  const radius = size / 2 - 10;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference * (1 - Math.min(1, Math.max(0, score / max)));
  const color = status?.color || "#E11D48";
  const label = status?.label || "—";

  return (
    <div className="flex flex-col items-center gap-4" data-testid="beatcredsi-score-ring">
      <div className="relative flex items-center justify-center" style={{ width: size, height: size }}>
        <svg width={size} height={size} className="-rotate-90">
          <circle cx={size / 2} cy={size / 2} r={radius} stroke="rgba(255,255,255,0.08)" strokeWidth="8" fill="none" />
          <circle cx={size / 2} cy={size / 2} r={radius} stroke={color} strokeWidth="8" fill="none"
            strokeDasharray={circumference} strokeDashoffset={offset} strokeLinecap="round"
            style={{ transition: "stroke-dashoffset 1.2s ease-out, stroke 0.6s ease" }} />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
          <div className="font-mono-tech text-[13px] uppercase tracking-[0.25em] text-amber-500/80 mb-2">BeatCredsi™</div>
          <div data-testid="beatcredsi-score-value">
            <LcdDisplay value={score} digits={4} size="md" bare />
          </div>
          <div className="font-mono-tech text-xs text-amber-500/60 mt-2 tracking-widest">/ {max}</div>
        </div>
      </div>
      <div
        className="font-mono-tech text-xs uppercase tracking-[0.18em] font-semibold px-3 py-1 border"
        style={{ color, borderColor: `${color}55`, backgroundColor: `${color}10` }}
        data-testid="beatcredsi-status-label">
        {label}
      </div>
    </div>
  );
}
